import {HiOutlineMail} from 'react-icons/hi'
import {RiMessengerLine} from 'react-icons/ri'
import {FaWhatsapp} from 'react-icons/fa'

const data = [
    {id: 1, icon: <HiOutlineMail/>, link: 'mailto:stamplato@gmail.com'},
    {id: 2, icon: <RiMessengerLine/>, link: 'https://www.messenger.com/t/10230126400291413'},
    {id: 3, icon: <FaWhatsapp/>, link: 'https://wa.me/+306976094545'}
]


// alternative whatsApp link
// https://wa.me/yournumber
// https://api.whatsapp.com/send/?phone=%2B233557097546


export default data